export default "__VITE_ASSET__OMXDlVle__"